import { render } from "./Validators.vue?vue&type=template&id=027e6c60"
import script from "./Validators.vue?vue&type=script&lang=ts"
export * from "./Validators.vue?vue&type=script&lang=ts"
script.render = render

export default script